import { createSlice } from '@reduxjs/toolkit';

interface IFormInfo {
  activeBanner: Record<string, any> | null;
  categoryBanner: Record<string, any> | null;
  collectionBanner: Record<string, any> | null;
}

const initialState: IFormInfo = {
  activeBanner: null,
  categoryBanner: null,
  collectionBanner: null,
};

const editBannerForm = createSlice({
  name: 'editBannerForm',
  initialState,
  reducers: {
    setActiveForm(state, action) {
      return {
        ...state,
        activeBanner: action.payload.data,
      };
    },
    setCategoryForm(state, action) {
      return {
        ...state,
        categoryBanner: action.payload.data,
      };
    },

    setCollectionForm(state, action) {
      return {
        ...state,
        collectionBanner: action.payload.data,
      };
    },
  },
});

export const actions = editBannerForm.actions;
export const reducer = editBannerForm.reducer;
